import { Link } from "react-router-dom";
import { ArrowUpRight, BookOpen, Feather } from "lucide-react";
import { LAW_STUDY, SOURCE_SHEETS, ESSAYS } from "../../data/study";

const RailLink = ({ to, icon: Icon, kicker, title, testId }) => (
  <Link
    to={to}
    data-testid={testId}
    className="group flex items-start gap-3 border-t hairline py-3.5 transition-colors"
  >
    <Icon size={14} strokeWidth={1.5} className="mt-1 shrink-0 text-terracotta" />
    <span className="min-w-0 flex-1">
      <span className="block font-mono text-[9px] uppercase tracking-[0.2em] text-ink-muted">{kicker}</span>
      <span className="link-underline mt-0.5 inline-block text-sm leading-snug text-ink">{title}</span>
    </span>
    <ArrowUpRight size={14} className="mt-1 shrink-0 text-ink-muted transition-transform duration-300 group-hover:rotate-45 group-hover:text-terracotta" />
  </Link>
);

export const StudyRail = ({ slug }) => {
  const cfg = LAW_STUDY[slug];
  if (!cfg) return null;
  const sheet = SOURCE_SHEETS.find((s) => s.id === cfg.sheet);
  const essays = cfg.essays.map((e) => ESSAYS.find((x) => x.slug === e)).filter(Boolean);

  return (
    <div data-testid="law-study-rail" className="mt-12 bg-parchment-deep/70 p-5">
      <p className="eyebrow">Continue learning</p>
      <p className="mt-2 text-xs leading-relaxed text-ink-muted">For serious study: the texts behind this law, and the ideas beneath it.</p>
      <div className="mt-4">
        <RailLink
          to={`/study/sources/${sheet.id}`}
          icon={BookOpen}
          kicker="Source sheet"
          title={sheet.title}
          testId={`law-study-sheet-${sheet.id}`}
        />
        {essays.map((e) => (
          <RailLink
            key={e.slug}
            to={`/study/essays/${e.slug}`}
            icon={Feather}
            kicker={`Essay · ${e.readingTime}`}
            title={e.title}
            testId={`law-study-essay-${e.slug}`}
          />
        ))}
      </div>
      <Link to="/study" data-testid="law-study-hall-link" className="link-underline mt-4 inline-block text-xs font-medium text-terracotta">
        Enter the Study Hall
      </Link>
    </div>
  );
};
